import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import React, { useEffect, useState } from "react";

import SearchBar from "../../components/SearchBar";
import TableComponent from "../../components/TableComponent";
import { showError, showToast } from "../../helpers/showToast";
import { Loader } from "../../helpers";
import AddFaq from "../../Modals/addFaq";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { useLazyDeleteFaqQuery, useLazyGetFAQQuery } from "../../service/cms";
import { FaqRes } from "../../types/General";
import { isValidInput } from "../../utils/validations";

const ManageFaq = () => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [page, setPage] = useState<number>(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedFaq, setSelectedFaq] = useState<FaqRes | null>(null);
  const [openDelete, setOpenDelete] = useState(false);

  const [count, setCount] = useState(0);
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const [getFaqsList] = useLazyGetFAQQuery();
  const [deleteFaq] = useLazyDeleteFaqQuery();
  const [faq, setFaq] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  //getFaq
  const getFaqList: any = async () => {
    setLoading(true);
    try {
      const response = await getFaqsList({
        page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.statusCode === 200) {
        setLoading(false);
        setFaq(response?.data?.list || []);
        setCount(response?.data?.totalCount || 0);
      } else {
        setLoading(false);
        setFaq([]);
        setCount(0);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };
  const handleDelete = async () => {
    try {
      const response = await deleteFaq({ id: selectedId }).unwrap();
      setLoading(false);
      if (response?.statusCode === 200) {
        showToast("Deleted successfully");
        getFaqList();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const columns: GridColDef<(typeof faq)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: "question",
      headerName: "Question",
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Tooltip title={row?.question?.en}>
              <p>
                {row?.question?.en?.length > 30
                  ? row?.question?.en.slice(0, 30) + "..."
                  : row?.question?.en || "-"}
              </p>
            </Tooltip>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: "answer",
      headerName: "Answer",
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Tooltip title={row?.answer?.en}>
              <p>
                {row?.answer?.en?.length > 30
                  ? row?.answer?.en.slice(0, 30) + "..."
                  : row?.answer?.en || "-"}
              </p>
            </Tooltip>
          </div>
        );
      },
    },

    {
      flex: 0.8,
      minWidth: 200,
      field: "date",
      headerName: "Date",
      sortable: false,
      filterable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.createdAt).format("DD MMM YYYY")}</p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => {
        return <Actioncell row={row} setOpenModal={setOpenModal} />;
      },
    },
  ];
  const Actioncell = ({ row, setOpenModal }: any) => {
    const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
    const open1 = Boolean(anchorEl1);
    const handleClick1 = (
      event: React.MouseEvent<HTMLButtonElement>,
      row: FaqRes
    ) => {
      setAnchorEl1(event.currentTarget);
      setSelectedId(row?._id);
      setSelectedFaq(row);
    };
    const handleClose1 = () => {
      setAnchorEl1(null);
    };

    return (
      <div className="table_actions">
        <Box>
          <IconButton
            aria-controls={open1 ? "basic-menu1" : undefined}
            aria-haspopup="true"
            aria-expanded={open1 ? "true" : undefined}
            onClick={(event) => handleClick1(event, row)}
          >
            <img src="/static/images/more_icon.svg" alt="" />
          </IconButton>
          <Menu
            className="setting_menu"
            id="basic-menu1"
            anchorEl={anchorEl1}
            open={open1}
            onClose={handleClose1}
            MenuListProps={{
              "aria-labelledby": "basic-button1",
            }}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                borderRadius: "8px",
                mt: 1,
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              onClick={() => {
                setSelectedId(row?._id);
                setOpenModal(true);
                handleClose1();
              }}
            >
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => {
                setSelectedId(row?._id);
                handleClose1();
                setOpenDelete(true);
              }}
            >
              Delete
            </MenuItem>
          </Menu>
        </Box>
      </div>
    );
  };
  useEffect(() => {
    getFaqList();
  }, [debouncedSearchTerm, page]);

  return (
    <div>
      <Loader isLoad={loading} />

      <div className="main_title">
        <div className="cards">
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    placeholder="Search"
                    setDebouncedSearchTerm={setDebouncedSearchTerm}
                    value={searchTerm}
                    onCross={() => setSearchTerm("")}
                    onChange={(val: any) => {
                      if (isValidInput(val.target.value)) {
                        setSearchTerm(val.target.value);
                      }
                    }}
                  />
                </Box>
              </div>
              <div className="right_s">
                <Box>
                  <Button
                    className="btn btn_orange"
                    onClick={() => {
                      setSelectedId("");
                      setSelectedFaq(null);
                      setOpenModal(true);
                    }}
                  >
                    Add faq
                  </Button>
                </Box>
              </div>
            </div>

            <TableComponent
              columns={columns}
              rows={faq}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </Box>
        </div>
      </div>
      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        selectedId={selectedId}
        selectedFaq={selectedFaq}
        getFaqList={getFaqList}
      />
      <ConfirmationModal
        text={"Are you sure to delete this FAQ?"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </div>
  );
};

export default ManageFaq;
